import {Injectable} from '@angular/core';
import {Action, State, StateContext} from '@ngxs/store';
import {CampaignsStateModel} from '@store/campaigns/campaigns-state.model';
import {CampaignsService} from '@services/campaingns/campaigns.service';
import {
  DisableCampaignsLoader,
  EnableCampaignsLoader,
  FetchCampaigns,
  GetCampaignsByType,
  SearchCampaigns,
  SetCampaignsPage,
  SortCampaigns
} from '@store/campaigns/campaigns.actions';
import {Observable, throwError} from 'rxjs';
import {CampaignTypeEnum} from '@shared/enums/campaign-type.enum';
import {catchError, tap} from 'rxjs/operators';
import {IResponse} from '@interfaces/response';
import {ICampaign, ICampaignActive, ICampaignHistory, } from '@interfaces/campaigns';

@State<CampaignsStateModel>({
  name: 'campaignState',
  defaults: {
    campaigns: null,
    currentPage: 1,
    searchParam: '',
    sort: 'id',
    order: 'DESC',
    itemsPerPage: 10,
    loader: false,
    type: CampaignTypeEnum.requested,
  }
})

@Injectable({
  providedIn: 'root',
})

export class CampaignsState {
  constructor(private campaignsService: CampaignsService) {
  }

  @Action(FetchCampaigns, {cancelUncompleted: true})
  fetchCampaigns(ctx: StateContext<CampaignsStateModel>): Observable<any> {
    const limit = ctx.getState().itemsPerPage;
    const skip = limit * (ctx.getState().currentPage - 1);
    const search = ctx.getState().searchParam;
    const order = ctx.getState().order;
    const sort = ctx.getState().sort;
    const type = ctx.getState().type;

    ctx.dispatch(new EnableCampaignsLoader());
    return this.campaignsService.getCampaigns(type, {limit, skip, search, order, sort})
      .pipe(
        tap((campaigns: IResponse<ICampaign | ICampaignActive | ICampaignHistory>) => {
          const state = ctx.getState();
          ctx.setState({...state, campaigns});
          ctx.dispatch(new DisableCampaignsLoader());
        }),
        catchError((error) => {
          ctx.dispatch(new DisableCampaignsLoader());
          return throwError(error);
        })
      );
  }

  @Action(GetCampaignsByType)
  getCampaignsByType(ctx: StateContext<CampaignsStateModel>, {type}: GetCampaignsByType): Observable<void> {
    ctx.patchState({type, currentPage: 1, searchParam: '', sort: 'id', order: 'DESC'});
    return ctx.dispatch(new FetchCampaigns());
  }

  @Action(SortCampaigns)
  sortCampaigns(ctx: StateContext<CampaignsStateModel>, {payload}: SortCampaigns): Observable<void> {
    ctx.patchState({sort: payload.sort, order: payload.order});
    return ctx.dispatch(new FetchCampaigns());
  }

  @Action(SearchCampaigns)
  searchCampaigns(ctx: StateContext<CampaignsStateModel>, {value}: SearchCampaigns): Observable<void> {
    ctx.patchState({searchParam: value, currentPage: 1});
    return ctx.dispatch(new FetchCampaigns());
  }

  @Action(SetCampaignsPage)
  setCampaignsPage(ctx: StateContext<CampaignsStateModel>, {page}: SetCampaignsPage): Observable<void> {
    ctx.patchState({currentPage: page});
    return ctx.dispatch(new FetchCampaigns());
  }

  @Action(EnableCampaignsLoader)
  enableCampaignsLoader(ctx: StateContext<CampaignsStateModel>): void {
    ctx.patchState({loader: true});
  }

  @Action(DisableCampaignsLoader)
  disableCampaignsLoader(ctx: StateContext<CampaignsStateModel>): void {
    ctx.patchState({loader: false});
  }
}
